(function () {
  function initFinder(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var section = root.closest('.shopify-section') || document;

    var T = JSON.parse(section.querySelector('[data-finder-strings]').textContent);
    var cats = [];
    try { cats = JSON.parse(section.querySelector('[data-finder-custom]').textContent).filter(function (c) { return c && c.handle; }); } catch (e) {}
    var handles = (root.dataset.collections || 'finder-camera,finder-lens,finder-packs').split(',');
    var base = root.dataset.root || '/';
    if (base.slice(-1) !== '/') base += '/';

    var MOUNT_ORDER = ['Canon RF', 'Canon EF', 'Nikon Z', 'Nikon F', 'Sony E/FE', 'Fujifilm XF', 'Fujifilm GFX', 'Hasselblad XCD', 'Leica M', 'Leica S', 'L-Mount', 'Micro Four Thirds'];
    var FINISH_ORDER = ['Classic', 'Gloss', 'Silver Foil', 'Gold Foil', 'Limited Edition'];
    var BRANDS = { canon: 'Canon', nikon: 'Nikon', sony: 'Sony', fujifilm: 'Fujifilm', hasselblad: 'Hasselblad', leica: 'Leica', lumix: 'Lumix', panasonic: 'Panasonic', sigma: 'Sigma', tamron: 'Tamron', viltrox: 'Viltrox', zeiss: 'Zeiss', 'om system': 'OM System' };
    var BRAND_RE = /\b(canon|nikon|sony|fujifilm|hasselblad|leica|lumix|panasonic|sigma|tamron|viltrox|zeiss|om system)\b/i;

    var $ = function (s) { return root.querySelector(s); };
    var el = {
      tabs: root.querySelectorAll('[data-tab]'),
      search: $('[data-search]'),
      steps: { mount: $('[data-step="mount"]'), brand: $('[data-step="brand"]'), finish: $('[data-step="finish"]') },
      chips: { mount: $('[data-chips="mount"]'), brand: $('[data-chips="brand"]'), finish: $('[data-chips="finish"]') },
      reset: $('[data-reset]'),
      status: $('[data-status]'),
      results: $('[data-results]'),
      resultsTitle: $('[data-results-title]'),
      stepLabel: root.querySelector('[data-step="mount"] .label-finder__step-label'),
      extras: $('[data-extras]'),
      extrasResults: $('[data-extras-results]')
    };

    var items = [];
    var state = { type: 'lens', mount: null, brand: null, finish: null, cat: null, cbrand: null, q: '' };
    var customCache = {};

    // Focal-length ranges (16-35) stay one word, so "35" matches a 35 mm lens but not a 16-35.
    // While typing, "16-" and "16-3" count as the start of a range.
    function norm(s, typing) {
      return String(s || '').toLowerCase()
        .replace(typing ? /(\d{2,})\s*[-–—]\s*(?=\d|$)/g : /(\d{2,})\s*[-–—]\s*(?=\d{2,})/g, '$1~')
        .replace(/[\-_\/.,()]/g, ' ').replace(/\s+/g, ' ').trim();
    }
    function uniq(a) { return a.filter(function (v, i) { return v && a.indexOf(v) === i; }); }
    function sortBy(order, list) {
      return list.slice().sort(function (a, b) {
        var ia = order.indexOf(a), ib = order.indexOf(b);
        if (ia < 0) ia = 99; if (ib < 0) ib = 99;
        return ia === ib ? a.localeCompare(b) : ia - ib;
      });
    }
    function mk(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    function typeLabel() { return state.type === 'lens' ? 'Lens label' : 'Camera label'; }
    function hasMount(it, m) { return (it.m || []).indexOf(m) > -1; }
    function brandOf(it) {
      var m = BRAND_RE.exec(it.t || '');
      return m ? BRANDS[m[1].toLowerCase()] : null;
    }

    function fetchCollection(h) {
      var url = base + 'collections/' + h + '?view=finder';
      return fetch(url + '&page=1').then(function (r) { return r.json(); }).then(function (first) {
        var out = first.items || [];
        var more = [];
        for (var p = 2; p <= (first.pages || 1); p++) {
          more.push(fetch(url + '&page=' + p).then(function (r) { return r.json(); }).then(function (d) { return d.items || []; }));
        }
        return Promise.all(more).then(function (rest) { return out.concat.apply(out, rest); });
      });
    }

    function fetchAll() {
      return Promise.all(handles.map(fetchCollection)).then(function (all) { return [].concat.apply([], all); });
    }

    function card(it, hint, imgPath, variantId) {
      var a = mk('a', 'label-finder__card');
      a.href = it.u + (variantId ? '?variant=' + variantId : '');
      var src = imgPath ? '/cdn/shop/' + imgPath : it.i;
      if (src) {
        var img = mk('img', 'label-finder__img');
        img.src = src; img.alt = ''; img.loading = 'lazy';
        img.style.height = 'auto'; img.style.aspectRatio = '1 / 1'; img.style.objectFit = 'cover';
        a.appendChild(img);
      } else { a.appendChild(mk('div', 'label-finder__img')); }
      var body = mk('div');
      var tag = [T.types[it.ty], it.f, it.l].filter(Boolean).join(' · ');
      if (tag) body.appendChild(mk('p', 'label-finder__tag', tag));
      body.appendChild(mk('p', 'label-finder__name', hint || it.t));
      if (hint) body.appendChild(mk('p', 'label-finder__fits', it.t));
      var price = mk('p', 'label-finder__price');
      if (it.a === false) {
        price.textContent = T.soldOut;
      } else if (it.c) {
        var was = mk('s', null, it.c);
        was.style.opacity = '.6';
        was.style.marginRight = '8px';
        price.appendChild(was);
        var now = mk('span', null, it.p);
        now.style.fontWeight = '600';
        price.appendChild(now);
      } else {
        price.textContent = it.p;
      }
      body.appendChild(price);
      a.appendChild(body);
      return a;
    }

    function chips(kind, values, current, onPick) {
      var box = el.chips[kind];
      box.textContent = '';
      values.forEach(function (v) {
        var b = mk('button', 'label-finder__chip', v);
        b.type = 'button';
        b.setAttribute('aria-pressed', String(v === current));
        b.addEventListener('click', function () { onPick(v); });
        box.appendChild(b);
      });
    }

    function showNone(target) {
      target.textContent = '';
      var wrap = mk('div', 'label-finder__none');
      wrap.style.gridColumn = '1 / -1';
      wrap.appendChild(mk('p', null, T.noneTitle)).style.fontWeight = '600';
      var p = mk('p'); p.appendChild(document.createTextNode(T.noneText + ' '));
      var a = mk('a', null, '→'); a.href = T.contact; p.appendChild(a);
      wrap.appendChild(p);
      target.appendChild(wrap);
    }

    function setStatus(n) {
      el.status.textContent = n === 1 ? T.one : (n + ' ' + T.many);
    }

    function showCustom() {
      var cat = cats.filter(function (c) { return c.label === state.cat; })[0];
      if (!cat) return;
      var picked = state.cat;
      var done = function (list) {
        if (state.type !== 'custom' || state.cat !== picked || norm(state.q).length >= 2) return;
        el.results.textContent = '';
        el.status.textContent = '';
        el.resultsTitle.hidden = true;
        el.steps.brand.hidden = true;
        var shown = list;
        var brands = uniq(list.map(brandOf)).sort();
        if (brands.length > 1) {
          el.steps.brand.hidden = false;
          chips('brand', brands, state.cbrand, function (v) { state.cbrand = v; render(); });
          if (!state.cbrand) return;
          shown = list.filter(function (it) { var b = brandOf(it); return !b || b === state.cbrand; });
        }
        el.resultsTitle.textContent = shown.length === 1 ? T.titleCustomOne : T.titleCustom;
        el.resultsTitle.hidden = false;
        shown.forEach(function (it) { el.results.appendChild(card(it)); });
      };
      if (customCache[cat.handle]) { done(customCache[cat.handle]); return; }
      el.status.textContent = T.loading;
      fetchCollection(cat.handle).then(function (list) {
        customCache[cat.handle] = list.filter(function (it) { return it && it.t; });
        done(customCache[cat.handle]);
      }).catch(function () { el.status.textContent = T.error; });
    }

    function render() {
      el.results.textContent = '';
      el.extrasResults.textContent = '';
      el.extras.hidden = true;
      el.resultsTitle.hidden = true;
      var q = norm(state.q, true);

      if (q.length >= 2) {
        Object.keys(el.steps).forEach(function (k) { el.steps[k].hidden = true; });
        el.reset.hidden = true;
        var tokens = q.split(' ');
        var lastIdx = tokens.length - 1;
        var hits = [];
        var order = 0;
        var wordsOf = function (str) { return norm(str).split(' '); };
        var squash = function (str) { return String(str || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
        // 2 = whole-word match, 1 = partial match, 0 = no match.
        // Tokens with digits (200, 40, f2) must match a whole word, so "20-40" never matches "200-400".
        // Only the last token, which may still be typing, can match as a prefix.
        var has = function (t, words, sq, isLast) {
          var hasDigit = /\d/.test(t), hasLetter = /[a-z]/.test(t), best = 0;
          for (var k = 0; k < words.length; k++) {
            if (words[k].indexOf('~') > -1 && t.indexOf('~') < 0) {
              // A plain number matches the start of a range (24 finds 24-105), never the end (35 does not find 16-35).
              var start = words[k].split('~')[0];
              if (start === t || (isLast && start.indexOf(t) === 0)) best = Math.max(best, 1);
              continue;
            }
            if (words[k] === t) return 2;
            if (words[k].indexOf(t) === 0 && (!hasDigit || isLast)) best = 1;
          }
          if (!best && t.length >= 4 && (!hasDigit || hasLetter) && sq.indexOf(t) > -1) best = 1;
          return best;
        };
        items.forEach(function (it) {
          var hayStr = [it.t, it.b, (it.m || []).join(' '), it.f, it.l].join(' ');
          var hw = wordsOf(hayStr), hs = squash(hayStr);
          var inHay = function (t, k) { return has(t, hw, hs, k === lastIdx); };
          var variants = (it.s || '').split('|');
          var vimgs = (it.vi || '').split('|');
          var vids = (it.vd || '').split('|');
          var found = false;
          for (var i = 0; i < variants.length; i++) {
            var vw = wordsOf(variants[i]), vs = squash(variants[i]);
            var inV = function (t, k) { return has(t, vw, vs, k === lastIdx); };
            var scores = tokens.map(function (t, k) { return Math.max(inHay(t, k), inV(t, k)); });
            var anyV = tokens.some(function (t, k) { return inV(t, k) > 0; });
            if (scores.every(function (s) { return s > 0; }) && anyV) {
              hits.push({ it: it, hint: variants[i], img: vimgs[i] || '', vid: vids[i] || '', score: scores.reduce(function (a, b) { return a + b; }, 0), n: order++ });
              found = true;
            }
          }
          if (!found) {
            var s2 = tokens.map(function (t, k) { return inHay(t, k); });
            if (s2.every(function (s) { return s > 0; })) hits.push({ it: it, hint: '', img: '', vid: '', score: s2.reduce(function (a, b) { return a + b; }, 0), n: order++ });
          }
        });
        hits.sort(function (a, b) { return (b.score - a.score) || (a.n - b.n); });
        if (!hits.length) { el.status.textContent = ''; showNone(el.results); return; }
        setStatus(hits.length);
        hits.slice(0, 60).forEach(function (h) { el.results.appendChild(card(h.it, h.hint, h.img, h.vid)); });
        return;
      }

      if (state.type === 'custom') {
        el.stepLabel.textContent = '1 · ' + T.stepType;
        el.steps.mount.hidden = false;
        el.steps.brand.hidden = true;
        el.steps.finish.hidden = true;
        chips('mount', cats.map(function (c) { return c.label; }), state.cat, function (v) { state.cat = v; state.cbrand = null; render(); });
        el.reset.hidden = !state.cat;
        if (!state.cat) { el.status.textContent = ''; return; }
        showCustom();
        return;
      }
      el.stepLabel.textContent = '1 · ' + T.stepMount;

      var typed = items.filter(function (it) { return it.ty === typeLabel(); });
      var mounts = sortBy(MOUNT_ORDER, uniq([].concat.apply([], typed.map(function (it) { return it.m || []; }))));
      el.steps.mount.hidden = false;
      chips('mount', mounts, state.mount, function (v) { state.mount = v; state.brand = null; state.finish = null; render(); });
      el.reset.hidden = !state.mount;

      el.steps.brand.hidden = true;
      el.steps.finish.hidden = true;
      if (!state.mount) { el.status.textContent = ''; return; }

      var pool = typed.filter(function (it) { return hasMount(it, state.mount); });
      var shown = pool;

      if (state.type === 'lens') {
        var brands = uniq(pool.map(function (it) { return it.b; })).sort();
        if (brands.length > 1) {
          el.steps.brand.hidden = false;
          chips('brand', brands, state.brand, function (v) { state.brand = v; render(); });
          if (!state.brand) { el.status.textContent = ''; return; }
          shown = pool.filter(function (it) { return it.b === state.brand; });
        }
      } else {
        var finishes = sortBy(FINISH_ORDER, uniq(pool.map(function (it) { return it.f; })));
        if (finishes.length > 1) {
          el.steps.finish.hidden = false;
          chips('finish', finishes, state.finish, function (v) { state.finish = v; render(); });
          if (!state.finish) { el.status.textContent = ''; return; }
          shown = pool.filter(function (it) { return it.f === state.finish; });
        }
      }

      el.status.textContent = '';
      el.resultsTitle.textContent = shown.length === 1 ? T.titleIndividual : T.titleIndividualMany;
      el.resultsTitle.hidden = !shown.length;
      shown.forEach(function (it) { el.results.appendChild(card(it)); });

      var extras = items.filter(function (it) {
        if (!hasMount(it, state.mount)) return false;
        return it.ty === 'Stealth kit' || (state.type === 'lens' && it.ty === 'Lens pack');
      });
      if (extras.length) {
        el.extras.hidden = false;
        extras.forEach(function (it) { el.extrasResults.appendChild(card(it)); });
      }
    }

    el.tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        state.type = b.dataset.tab; state.mount = null; state.brand = null; state.finish = null; state.cat = null; state.cbrand = null;
        el.tabs.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        render();
      });
    });
    var onSearch = function () { state.q = el.search.value; render(); };
    el.search.addEventListener('input', onSearch);
    el.search.addEventListener('search', onSearch);
    el.reset.addEventListener('click', function () { state.mount = null; state.brand = null; state.finish = null; state.cat = null; state.cbrand = null; render(); });

    fetchAll().then(function (all) {
      items = all.filter(function (it) { return it && it.t; });
      el.search.disabled = false;
      el.status.textContent = '';
      render();
    }).catch(function () { el.status.textContent = T.error; });
  }
  document.querySelectorAll('[data-label-finder]').forEach(initFinder);
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-label-finder]').forEach(initFinder);
  });
})();
